import * as Firebase from 'firebase/app'
import 'firebase/firestore'

var firebaseConfig = {
    apiKey: "AIzaSyD7886XcltRD-iaEjiAWCCb-NF4trO7WOE",
    authDomain: "bibliotrees-8a7b1.firebaseapp.com",
    databaseURL: "https://bibliotrees-8a7b1.firebaseio.com",
    projectId: "bibliotrees-8a7b1",
    storageBucket: "bibliotrees-8a7b1.appspot.com",
    messagingSenderId: "648301271248",
    appId: "1:648301271248:web:dcb9991cddc0b9618866d5",
    measurementId: "G-2PSP8QSGGQ"
};

function initFirebase() {
    Firebase.initializeApp(firebaseConfig)
    return new Promise((resolve, reject) => {
        Firebase.firestore().enablePersistence()
            .then(resolve)
            .catch(err => {
                if (err.code === 'failed-precondition') {
                    reject(err)
                        // Multiple tabs open, persistence can only be
                        // enabled in one tab at a a time.
                } else if (err.code === 'unimplemented') {
                    reject(err)
                        // The current browser does not support all of
                        // the features required to enable persistence
                }
            })
    })
}

export { Firebase, initFirebase }


// WEBPACK FOOTER //
// ./src/config/firebase.js